
/**
 * Insert an emoji character directly into the specified textarea
 * @param {string} emoji - The emoji character to insert
 * @param {HTMLTextAreaElement} textarea - The textarea element to insert into
 */
export function insertEmojiInTextArea(emoji, textarea) {
    if (!textarea) return;

    // Get current cursor position
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;
    const scrollTop = textarea.scrollTop;

    // Insert the emoji at the cursor position
    const message = textarea.value.substring(0, startPos) + emoji + textarea.value.substring(endPos, textarea.value.length);

    // Move cursor to the end of the inserted emoji
    window.setTimeout(() => {
        textarea.selectionStart = startPos + emoji.length;
        textarea.selectionEnd = startPos + emoji.length;
        textarea.scrollTop = scrollTop;
        textarea.focus();
    }, 100);

    return message;
}